import React from 'react';
import DefaultLayout from '../../containers/Layouts/DefaultLayout';

export const SidebarLayout = props => (
  <div className="b-container fluid">
    <DefaultLayout {...props} container={false} />
  </div>
);
